import axios from "axios";
import { refreshSessionOrLogout } from "./interceptors";
import { commonHeaders } from "./commonHeader";
import TokenService from "./tokenManager";
import { toast } from "react-toastify";
import { API_BASE_URL } from "config";

const userClient = axios.create({
  baseURL: API_BASE_URL,
  headers: commonHeaders,
  withCredentials: false,
});

userClient.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      if (config.headers) config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

userClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Check for network error
    if (!error.response) {
      // toast.error('Kindly check your internet connection');
    }
    return Promise.reject(error);
  }
);

userClient.interceptors.response.use((res) => {
  return res;
}, refreshSessionOrLogout());

export default userClient;
